export default __webpack_public_path__ + "static/media/legend-rare.b04a1279.png";